import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@kodit/core/services';
import { CoreAuthModule } from '@kodit/core/auth';
import { AppLayoutComponent } from 'libs/core/core-ui/src/lib/layouts/app-layout/app-layout.component';
import { LoginLayoutComponent } from 'libs/core/core-ui/src/lib/layouts/login-layout/login-layout.component';
import { getChildrenRoutes } from './app-children-routes';
import { InactiveOrExpiredGuard } from '../../../../libs/core/services/src/lib/security/inactive-or-expired.guard';
import { PretplataPageComponent } from '../../../../libs/core/core-ui/src/lib/subscriptions/pretplata-page/pretplata-page.component';
import { OdabirPaketaForm2Component } from '../../../../libs/core/shared-subforms/src/lib/registracija/odabir-paketa-form2/odabir-paketa-form2.component';
import { ActiveGuard } from '../../../../libs/core/services/src/lib/security/active.guard';
import { InactiveOrExpiredLayout } from '../../../../libs/core/core-ui/src/lib/layouts/subscription-expired-layout/inactive-or-expired-layout.component';
import { PlacanjaPageComponent } from '../../../../libs/core/core-ui/src/lib/subscriptions/placanja-page/placanja-page.component';
import {
  PromenaFirmeLoaderComponent
} from '../../../../libs/core/core-ui/src/lib/promena-firme-loader/promena-firme-loader.component';
import { AccessDeniedPageComponent } from '../../../../libs/core/core-ui/src/lib/access-denied-page/access-denied-page.component';

const routes: Routes = [
  //Default
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard, ActiveGuard],
    children: [
      ...getChildrenRoutes(AuthGuard),
      {
        path: 'access-denied',
        component: AccessDeniedPageComponent,
      },
    ],
  },
  {
    path: 'promena-firme',
    component: PromenaFirmeLoaderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'expired',
    component: InactiveOrExpiredLayout,
    canActivate: [InactiveOrExpiredGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'pretplata',
      },
      {
        path: 'pretplata',
        component: PretplataPageComponent,
        data: {
          subExpired: true,
        },
      },
      {
        path: 'placanja',
        component: PlacanjaPageComponent,
        data: {
          subExpired: true,
        },
      },
      {
        path: 'paketi',
        component: OdabirPaketaForm2Component,
        data: {
          breadcrumb: 'Paketi',
          isNadogradnja: true,
        },
      },
    ],
  },
  // //InfoZgrada
  // {
  //   path: 'info-zgrada',
  //   component: AppLayoutComponent,
  //   canActivate: [InfoZgradaGuard],
  //   data: {
  //     isInfoZgrada: true
  //   },
  //   children: getChildrenRoutes(InfoZgradaGuard)
  // },
  //Login
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'autentikacija',
        loadChildren: () => CoreAuthModule,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/autentikacija',
      },
    ],
  },
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '/dashboard' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      // preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
